module.exports = __webpack_public_path__ + "static/media/default_image.7f6b4fcc.jpg";